
__webpack_require__.remotesLoadingData = { chunkMapping: {"576":["8731"]}, moduleIdToRemoteDataMapping: {"8731":{"shareScope":"default","name":"./auth","externalModuleId":1771,"remoteName":"super-app"}} };
__webpack_require__.f.remotes = __webpack_require__.f.remotes || function() { throw new Error("should have __webpack_require__.f.remotes"); }
